import axios from "axios";
import paginationIndicator from "../utils/pagination-indicator";

const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host + getUrl.pathname;

const ajaxLoadMore = (phpAction) => {

  const debug = false;
  const button = document.querySelector("#js-load-more-posts");

  // Results, Reports & Presentations page also has a <select> for year
  // select menu options do not have click events so will need onChange
  const selectMenu = document.getElementById('results-year')

  paginationIndicator();
  // Hide the featured post when we start filtering or loading more posts
  const hideFeaturedItem = () => {
    const feat = document.querySelector('.newsroom-featured');
    if(feat){
      feat.style = 'display:none';
    }
  }

  if (typeof button !== "undefined" && button !== null) {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      hideFeaturedItem();
      let current_page = document.querySelector(".js-results-container").dataset.page;
      let max_pages = document.querySelector(".js-results-container").dataset.max;
      let category = document.querySelector(".cat-list_item.active");
      let blog_id = document.querySelector(".js-results-container").dataset.blogid;
      let year;

      if(category){
        category = category.dataset.slug;
      }

      if(debug) {
        console.log("ajaxLoadMore", current_page);
        console.log("ajaxLoadMore", max_pages);
        console.log("ajaxLoadMore", "cat", category);
      }

      // Create serch params
      let params = new URLSearchParams();
      params.append("action", phpAction); // the PHP query function
      params.append("current_page", current_page);
      params.append("max_pages", max_pages);
      params.append("blog_id", blog_id);
      // Current category filter? (defaults to all)
      if (category && category !== "") {
        params.append("category", category);
      }
      if( selectMenu && year != '--Select a Year' ) {
        year = selectMenu.options[selectMenu.selectedIndex].text
        params.append("year", year)
      }

      // Display loading spinner when ajax request is being made
      axios.interceptors.request.use(function(config) {
        // Do something before request is sent
        document.querySelector('.spinner-outer').classList.add('-loading', '-pos-bottom');

        return config;
      }, function(error) {
        return Promise.reject(error);
      });
      // Remove loading spinner when done
      axios.interceptors.response.use(function(response) {
        // Do something with response data
        document.querySelector('.spinner-outer').classList.remove('-loading', '-pos-top');

        return response;
      }, function(error) {
        return Promise.reject(error);
      });

      axios.post("/wp-admin/admin-ajax.php", params)
      .then((res) => {
        if(debug){
          console.log({ res });
        }
        let posts_list = document.querySelector(".js-results-container");
        posts_list.insertAdjacentHTML("beforeend", res.data.data);
        setTimeout(paginationIndicator, 300);

        window.history.pushState(
          "",
          "",
          baseUrl +
            "page/" +
            (parseInt(document.querySelector(".js-results-container").dataset.page) +
              1)
        );
        if(debug) {
          console.log(
              "ajaxLoadMore", 'page',
              parseInt(document.querySelector(".js-results-container").dataset.page)
          );
        }
        document.querySelector(".js-results-container").dataset.page++;

        if (
          document.querySelector(".js-results-container").dataset.page ==
          document.querySelector(".js-results-container").dataset.max
        ) {
          //button.parentNode.removeChild(button);
          button.classList.add('-hide');
        } else {
          button.classList.remove('-hide');
        }
      });
    });
  }
};

// Newsroom filters
const newsroom = document.querySelector('.newsroom-main');
// Results, Reports & Presentations filters
const resultsReports = document.querySelector('.js-results-reports')
if(newsroom){
  ajaxLoadMore('load_more_posts');
}
if(resultsReports){
  ajaxLoadMore('load_more_resultsreports');
}
